import React, {Component} from "react";
/*
    Importing redux to get access to Applicant name
*/
import { connect } from "react-redux";
import { updateForm, setStep, setDoc } from "../../../store/actions/FormAction";
/*
    Importing LoanSlider that is a component that loanamt in Redux
*/
import WelcomeSlider from "../../partials/WelcomeSlider";
/*
    Importing NextStepButton that is a component that updates the page in Redux
*/
import NextButton from "../../partials/NextButton";
/*
    Importing AlertDialogSlide for sliding Modal Window
*/
import AlertDialogSlide from "../../partials/AlertDialogSlide";
/*
    Custom styling of the range slider (Welcome.css)
*/
import '../StartApplication/gsap.css';
import '../StartApplication/Slider.css';
/*
    This page is using a template WelcomeLayout - no progressbar and no nav
*/
import WelcomeLayout from '../../../containers/WelcomeLayout.js';

/*
    Welcome view that displays the Welcome page
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
    SVGs need to have the xml attributes removed
*/
class Welcome extends Component {
  componentDidMount() {
    //TODO FOR TESTING PURPOSES ONLY
    this.props.setStep(0);
    this.props.setDoc(0);

    this.props.updateForm("pagename", "Apply Now");

    if (this.props.stt === "CA"){
      document.getElementById("loanslider").classList.add('hidden');
      document.getElementById("loanamount").classList.remove('hidden');
    }
  }

  componentWillUnmount() {
    window.scrollTo(0, 0);
  }

  render() {
      const nextStep = 0;
      const nextLink = "/createaccount";
      const btnText = "Get My Money";
      const btnClasses = "btn padtop first-step";

      let approved = this.props.approvedamt;
      if (approved < 100){
        this.props.updateForm("approvedamt", 500);
        approved = 500;
      }

      if (this.props.stt === "CA"){
        this.props.updateForm("loantype", "Payday Loan");
        this.props.updateForm("loanamt", 255);
        this.props.updateForm("minamt", 255);
        this.props.updateForm("maxamt", 255);
        this.props.updateForm("approvedamt", 255);
        approved = 255;
      }

      if (approved > this.props.maxamt){
        this.props.updateForm("approvedamt", this.props.maxamt);
        approved = this.props.maxamt;
      }

      let loan = <span>an <AlertDialogSlide linkText="installment loan" tip="installmentloans"/></span>
      if (this.props.loantype === "Payday Loan")
        loan = <span>a <AlertDialogSlide linkText="payday loan" tip="paydayloans"/></span>
      else if (this.props.loantype === "Line of Credit")
        loan = <span>a <AlertDialogSlide linkText="line of credit" tip="lineofcredit"/></span>

      return (
        <WelcomeLayout>
            <div className="container" id="step-1">
                <div className="text-center topcopy">
                    <h1>Welcome to MoneyKey!</h1>
                    <h5>Congratulations {this.props.fn},</h5>
                    <p>Based on your information, you’ve qualified for {loan} up to</p>
                </div>
                <form className="flowform">
                  <div id="loanamount" className="text-center hidden">
                    <h2>${approved}</h2>
                  </div>
                  <div id="loanslider" className="form-group" >
                    <WelcomeSlider />
                  </div>

                  <hr />

                  <div id="moneykeyloanprocess">
                      <div className="container">
                        <h5>Next steps:</h5>
                        <div className="moneykeyloanprocesscards">
                          <a className="moneykeyloanprocesscard" id="step1" data-toggle="modal" data-target="#myModal">
                            <div className="row">
                              <div className="processicon col-xs-3 col-sm-12">
                                <svg width="120px" viewBox="0 0 90 61" stroke="none" strokeWidth="2" fill="none" fillRule="evenodd">
                                  <path d="M73.1127,10.1412 L73.1127,23.2683 L69.5029,23.2683 C67.8162,23.2686 66.4472,24.6377 66.4472,26.324 L66.4472,47.0647 L28.0398,47.0647 C27.7592,46.7732 27.4847,46.4733 27.2163,46.1651 C36.0843,44.5096 47.6946,39.183 57.5609,30.2741 C64.3849,24.1123 69.6376,16.9024 73.1127,10.1412 Z" fill="#D5EDF2"></path>
                                  <path d="M66.4472,46.9224 L39.3032,46.9224 C38.9988,46.6856 38.7023,46.4403 38.4139,46.1863 C45.3049,45.3527 54.2522,42.3535 61.7524,37.1583 C63.4535,35.9799 65.02,34.7303 66.4472,33.4412 L66.4472,46.9224 Z" fill="#B5D7DE"></path>
                                  <path d="M11.0413,46.5492 L11.0413,5.17 C11.0413,4.9394 11.2284,4.7522 11.4591,4.7521 L72.4773,4.7521 C72.708,4.7522 72.8952,4.9394 72.8952,5.17 L72.8952,23.2683" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                                  <path d="M50.1214,46.5366 L50.1214,47.9747 C50.1214,49.8061 48.6346,51.2929 46.8032,51.293 L37.1456,51.293 C35.3074,51.293 33.815,49.8006 33.815,47.9623 L33.815,46.5366" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                                  <path d="M66.4472,55.626 L5.4282,55.626 C2.4323,55.626 0,53.1937 0,50.1978 L0,46.5366 L66.4472,46.5366" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                                  <path d="M6.7128,46.5366 L6.7128,6.0481 C6.7128,2.7102 9.4228,0.0001 12.7609,0 L71.423,0 C74.6245,0.0001 77.2236,2.5993 77.2236,5.8007 L77.2236,23.2683" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                                  <path d="M86.5294,52.8713 L69.8365,52.8713 C75.0473,50.2367 80.6089,45.844 84.8874,39.9622 C85.4679,39.1642 86.015,38.3522 86.5294,37.5301 L86.5294,52.8713 Z" fill="#DBF0F4"></path>
                                  <path d="M86.5294,52.8713 L71.9639,52.8713 C76.7364,51.3379 82.0921,48.1915 86.5294,43.5735 L86.5294,52.8713 Z" fill="#C0DDE3"></path>
                                  <path d="M88,26.324 C88,24.6375 86.6308,23.2683 84.9443,23.2683 L69.5029,23.2683 C67.8164,23.2683 66.4472,24.6375 66.4472,26.324 L66.4472,56.2043 C66.4472,57.8908 67.8164,59.26 69.5029,59.26 L84.9443,59.26 C86.6308,59.26 88,57.8908 88,56.2043 L88,26.324 Z" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                                  <path d="M77.3131,54.2401 C78.3092,54.2401 79.1179,55.0175 79.1179,55.9751 C79.1179,56.9327 78.3092,57.7102 77.3131,57.7102 C76.317,57.7102 75.5083,56.9327 75.5083,55.9751 C75.5083,55.0175 76.317,54.2401 77.3131,54.2401 Z" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                                  <path d="M72.9187,25.8744 L81.6965,25.8744" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                                </svg>
                              </div>
                              <div className="col-xs-9 col-sm-12">
                                <p>1. Review and Sign Agreement</p>
                              </div>
                            </div>
                          </a>
                          <a className="moneykeyloanprocesscard" id="step2" data-toggle="modal" data-target="#myModal">
                            <div className="row">
                              <div className="processicon col-xs-3 col-sm-12">
                                <svg height="120px" viewBox="0 0 56 64" stroke="none" strokeWidth="1.8" fill="none" fillRule="evenodd">
                                  <path d="M39.1654,49.9733 C31.4235,57.4497 19.0982,63.1245 19.0982,63.1245 L41.5841,62.6334 C41.5841,62.6334 46.3243,60.1885 47.4047,58.1805 C53.1642,47.4766 44.0565,42.7241 44.0565,42.7241 C44.0565,42.7241 43.1435,46.1316 39.1654,49.9733 Z" fill="#D5EDF2"></path>
                                  <path d="M40.9111,53.0221 C36.613,58.1403 28.8305,62.9103 28.8305,62.9103 L39.8066,62.8369 C39.8066,62.8369 45.1334,61.1755 45.8604,60.1428 C51.1099,52.6855 49.831,49.1819 46.122,43.8072 C45.4794,46.4848 44.2665,49.0264 40.9111,53.0221 Z" fill="#B5D7DE"></path>
                                  <path d="M13.0159,35.3888 C9.9074,40.3111 2.2843,39.8375 2.2843,39.8375 C2.2843,39.8375 2.2802,24.5408 2.528,17.3354 C2.9064,6.3365 12.7903,0.361 20.3114,0.5025 C27.7248,0.6419 37.529,6.6022 37.7683,17.1782 C37.9311,24.372 37.9712,39.8432 37.9712,39.8432 C37.9712,39.8432 31.391,40.5887 27.511,35.6087 C32.0281,32.4077 32.4954,28.2581 32.7581,26.2871 C33.0444,24.1391 33.0681,17.6128 32.9774,17.5511 C26.9097,13.4212 25.3898,10.7845 25.3898,10.7845 C25.3898,10.7845 18.6932,19.624 7.6718,18.9852 C7.5744,18.9796 7.3592,24.88 7.7098,27.5487 C7.7191,27.6195 8.5118,32.4838 13.0159,35.3888 Z" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                                  <path d="M25.2848,36.8597 C26.6506,36.2165 27.5628,35.5585 27.5628,35.5585" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                                  <path d="M12.9738,35.3694 C12.9738,35.3694 14.5106,36.597 16.0845,37.0373" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                                  <path d="M16.2303,41.9392 C16.2303,41.9392 2.4526,42.5084 0.5,52.7932" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                                  <path d="M25.1482,41.9392 C25.1482,41.9392 28.2337,42.0667 31.6913,43.291" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                                  <path d="M38.4256,40.9756 C44.4737,40.9756 49.3839,45.8858 49.3839,51.9339 C49.3839,57.9819 44.4737,62.8922 38.4256,62.8922 C32.3775,62.8922 27.4673,57.9819 27.4673,51.9339 C27.4673,45.8858 32.3775,40.9756 38.4256,40.9756 Z" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                                  <path id="cscheckmark" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" d="M30.9478 50.8411 37.9712 57.2192 55.3941 37.4227"></path>
                                  <path d="M13.5712,22.758 C14.3009,22.758 14.8934,23.3408 14.8934,24.0588 C14.8934,24.7767 14.3009,25.3595 13.5712,25.3595 C12.8414,25.3595 12.249,24.7767 12.249,24.0588 C12.249,23.3408 12.8414,22.758 13.5712,22.758 Z" fill="#000000"></path>
                                  <path d="M27.2567,22.758 C27.9865,22.758 28.5789,23.3408 28.5789,24.0588 C28.5789,24.7767 27.9865,25.3595 27.2567,25.3595 C26.527,25.3595 25.9345,24.7767 25.9345,24.0588 C25.9345,23.3408 26.527,22.758 27.2567,22.758 Z" fill="#000000"></path>
                                  <path d="M23.3755,29.5947 C23.3755,31.43 21.9108,32.9178 20.1041,32.9178 C18.2973,32.9178 16.8327,31.43 16.8327,29.5947 L23.3755,29.5947 Z" id="csmouth" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                                  <path d="M25.2348,36.8642 C25.2348,36.8642 25.1954,39.1077 25.195,39.1316 L25.1584,41.0134 C24.9924,43.4715 23.0271,45.3717 20.6051,45.3717 C18.1832,45.3717 16.232,43.4885 16.066,41.0304 L16.0172,39.2399 L16.0139,36.9998 C17.1025,37.3739 18.2064,37.7596 20.4675,37.8022 C22.2095,37.8349 23.9254,37.3814 25.2348,36.8642 Z" id="csneck" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                                </svg>
                              </div>
                              <div className="col-xs-9 col-sm-12">
                                <p>2. Speak with Customer Care</p>
                                  <p className="linktext">1-866-255-1668</p>
                              </div>
                            </div>
                          </a>
                          <a className="moneykeyloanprocesscard" id="step3" data-toggle="modal" data-target="#myModal">
                            <div className="row">
                              <div className="processicon col-xs-3 col-sm-12">
                                <svg width="120px" viewBox="0 0 64 68" strokeWidth="2.2" stroke="none" fill="none" fillRule="evenodd">
                                  <path d="M63.5,30.3834 L63.5,67.4212 L35.2354,67.4212 C41.8324,64.1154 48.91,58.6212 54.302,51.3465 C59.3351,44.556 62.3072,37.0133 63.5,30.3834 Z" fill="#DBF0F4"></path>
                                  <path d="M63.5,45.9545 L63.5,67.4212 L37.4044,67.4212 C44.7529,65.1538 53.3631,59.8427 59.5593,51.9343 C61.0691,50.0074 62.3796,47.9976 63.5,45.9545 Z" fill="#C0DDE3"></path>
                                  <path d="M27.2783,21.1426 L22.3366,22.0971 C22.3366,22.0971 20.103,22.5112 18.359,24.9678 C16.1942,28.017 8.3001,39.6007 8.3001,39.6007 C8.3001,39.6007 6.981,41.8252 4.3488,42.7364 C3.103,43.1677 0.5,43.6466 0.5,43.6466 L0.5,67.4212 L18.8743,63.8357 C18.8743,63.8357 20.9271,63.5435 22.8547,61.1038 C24.8013,58.64 27.3583,49.6568 27.3583,49.6568 C27.3583,49.6568 38.8028,46.6331 42.3267,45.7307 C44.09,45.2793 47.8991,42.7612 46.6888,37.8302 C45.4431,32.7554 40.2426,32.9994 39.4635,33.1929 C38.7325,33.3744 27.2783,36.4095 27.2783,36.4095 L27.2783,21.1426 Z" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                                  <path stroke="#000000" strokeLinecap="round" strokeLinejoin="round" d="M27.2783 36.4065 27.2783 0.5 63.5 0.5 63.5 67.4212 27.2783 67.4212 27.2783 49.7676 27.3583 49.6568"></path>
                                  <path d="M31.467,35.2993 L31.467,11.5864 C34.8733,11.0305 37.5658,8.3381 38.1216,4.9317 L53.1263,4.9317 C53.6715,8.2727 56.272,10.9269 59.5856,11.552 L59.5856,56.8042 C56.2887,57.4262 53.6978,60.0567 53.1347,63.3741 L37.9928,63.3741 C37.4255,60.0318 34.7995,57.3864 31.467,56.7903 L31.467,48.573" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                                  <path d="M34.6911,34.4478 C35.4513,29.1627 40.0029,25.0958 45.4969,25.0958 C51.5225,25.0958 56.4145,29.9878 56.4145,36.0134 C56.4145,42.0389 51.5225,46.9309 45.4969,46.9309 C43.9549,46.9309 42.4871,46.6105 41.1565,46.0327" stroke="#000000" strokeLinecap="round" strokeLinejoin="round"></path>
                                </svg>
                              </div>
                              <div className="col-xs-9 col-sm-12">
                                <p>3. Receive Your Money</p>
                              </div>
                            </div>
                          </a>
                        </div>
                    </div>
                  </div>
                  <div className="text-center ">
                    <NextButton next={nextLink} btnText={btnText} btnClasses={btnClasses} step={nextStep} />
                  </div>
                  <hr />
              </form>
              <div className="trustpilotwidget padtop">
                <span><strong className="ratingtext">Excellent &nbsp;</strong></span>
                <img src="/images/reviews/5_stars.png" className="trustpilotstars" alt="trustpilot-top-review-rating"/>
                <span className="hidden-xs">&nbsp; based on <strong>1,341</strong> reviews &nbsp;</span>
                <img src="/images/reviews/trustpilot_logo-dark.png" className="trustpilotlogo" alt="trustpilotlogo"/>
              </div>
            </div>
        </WelcomeLayout>
        );
    }
}

const mapStateToProps = (state) => ({
    fn: state.FormReducer.fn,
    loanamt: state.FormReducer.loanamt,
    loantype: state.FormReducer.loantype,
    stt: state.FormReducer.stt
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
    setStep: (step) => dispatch(setStep(step)),
    setDoc: (doc) => dispatch(setDoc(doc))
})

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);



// WEBPACK FOOTER //
// ./src/components/views/Welcome/index.js